/** @jsxImportSource @emotion/react */
import { getTokenOutSummary } from "../../../../utils/quoteUtils";
import React from "react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { getMakerTokens } from "../../../../store/global/selectors";
import { ReviewHeader } from "./elements/ReviewPayHeader";
import { css } from "@emotion/react";
import { amountFont, boldTokenFont } from "../../../../config/commonCSS";
import { getTokenIcon } from "../../../../utils/tokenIconUtils";
import {
  SelectedAddress,
  SelectedAddressDisplayLocations,
} from "../../../SwapAndSendSection/elements/SelectedAddress";
import { isAddress } from "viem";
import { INITIAL_RECEIVER_STATE, transformQuoteReceiver } from "../../../../utils/swapAndSendUtils";
import {
  ViewOnExplorer,
  ViewOnExplorerDisplayLocations,
} from "../../../SwapAndSendSection/elements/ViewOnExplorer";

export interface YouReceiveSectionProps {
  shouldDisplayLabel: boolean;
  completed?: boolean;
}

export const YouReceiveSection: React.FC<YouReceiveSectionProps> = props => {
  const makerTokens = GlobalStore.useState(getMakerTokens);
  const tokens = GlobalStore.useState(s => s.tokens);
  const quote = GlobalStore.useState(s => s.quote);
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const receiver = GlobalStore.useState(s => s.receiver);
  const validAddress = isAddress(receiver?.userInput ?? "");
  const isReceiver = receiver !== INITIAL_RECEIVER_STATE;
  const theme = GlobalStore.useState(s => s.theme);
  const receiveText = () => {
    if (props.completed) {
      return `You ${isReceiver ? "Sent" : "Received"} Exactly`;
    } else {
      return `You ${isReceiver ? "Send" : "Receive"} Exactly`;
    }
  };

  if (!quote && !wrapQuote) {
    return null;
  }

  return (
    <div className="review-pay br-14 mt-2">
      {props.shouldDisplayLabel && (
        <ReviewHeader>
          {" "}
          <div>{receiveText()}</div>
          {isReceiver && quote && (
            <div className="d-flex justify-content-between">
              <SelectedAddress
                receiver={transformQuoteReceiver(quote.receiver, receiver)}
                isValidAddress={validAddress}
                displayLocation={SelectedAddressDisplayLocations.ReviewOrder}
              />
              <ViewOnExplorer
                visible={true}
                address={quote.receiver}
                displayLocation={ViewOnExplorerDisplayLocations.Review}
              />
            </div>
          )}
        </ReviewHeader>
      )}
      {makerTokens.map((entry, index) => {
        const tokenName = tokens ? tokens[entry.token]?.name : entry.token;
        const amount = quote
          ? getTokenOutSummary(quote, entry.token).amount.toDisplay(entry.token, tokens)
          : wrapQuote?.amount?.toDisplay(entry.token, tokens);
        return (
          <span key={entry.token}>
            <div className="d-flex align-items-center justify-content-between">
              <div
                key={entry.token}
                className="col pay-review-token"
                css={css`
                  ${boldTokenFont(theme)};
                  font-size: ${theme.fontSize["6"]};
                  max-width: 280px;
                  overflow-x: hidden;
                `}
              >
                <img
                  src={getTokenIcon(entry.token, tokens)}
                  style={{ marginRight: "10px" }}
                  alt={`${entry.token} symbol`}
                />
                {tokenName}
              </div>
              <div className="col d-flex flex-column align-items-end pay-review-token mt-2">
                <div>
                  <span css={amountFont(theme)} data-sentry-mask="true">
                    {amount}{" "}
                  </span>
                  <span
                    css={css`
                      ${boldTokenFont(theme)};
                      font-weight: 550;
                    `}
                  >
                    {entry.token}
                  </span>
                </div>
                {quote && (
                  <span
                    className="pay-review-usd"
                    css={css`
                      ${amountFont(theme)};
                      font-size: ${theme.fontSize["5"]};
                      font-weight: ${theme.fontWeights["work-sans-2"]};
                      color: #808b8b;
                    `}
                  >
                    ${getTokenOutSummary(quote, entry.token).fiatValue.format(2)}
                  </span>
                )}
              </div>
            </div>
            {makerTokens.length > 0 && index !== makerTokens.length - 1 && (
              <hr className="hr-m-5" />
            )}
          </span>
        );
      })}
    </div>
  );
};
